import { render, staticRenderFns } from "./RegisterManufacturer.vue?vue&type=template&id=1c121db2&"
import script from "./RegisterManufacturer.vue?vue&type=script&lang=js&"
export * from "./RegisterManufacturer.vue?vue&type=script&lang=js&"
import style0 from "./RegisterManufacturer.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./RegisterManufacturer.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports